module.exports = __webpack_public_path__ + "media/src/images/partners/eu_commission-8fe6e166a66a1cb018a5471b4456c7f1.jpg";